import { NodeHierarchyClient, NodeHierarchyDto } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const nodeHierarchyClient = new NodeHierarchyClient(undefined, axios);

export const useNodeHierarchy = (options?: any) => {
  return useQuery<NodeHierarchyDto[] | null>({
    ...options,
    queryKey: ["nodeHierarchy"],
    initialData: null,
    queryFn: async () => nodeHierarchyClient.get(),
  });
};


